import AuthGuard from "./auth/AuthGuard";
import { createBrowserRouter, redirect } from "react-router-dom";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import Error404 from "./views/sessions/Error";
import adminRoutes from "./views/Admin/adminRoutes";
import distributorRoutes from "./views/Distributor/distributorRoutes";
import masterRoutes from "./views/Master-admin/masterRoutes";
import apiuserRoutes from "./views/Api-User/apiuserRoutes";
import supplierRoutes from "./views/Supplier/supplierRoutes";

const routes = createBrowserRouter([
  {
    element: <AuthGuard />,
    children: [
      ...adminRoutes,
      ...distributorRoutes,
      ...masterRoutes,
      ...apiuserRoutes,
      ...supplierRoutes,
    ],
  },
  ...sessionsRoutes,
  {
    path: "/",
    exact: true,
    loader: () => redirect("/signin"),
  },
  {
    path: "*",
    element: <Error404 />,
  },
]);

export default routes;
